// Angular Imports
import { Component, Input, ViewChild, EventEmitter, Output, OnInit } from '@angular/core';

// CC-Common Imports
import { IconConstants } from 'cc-common';

// 3rd party imports
import { DxPopupComponent } from 'devextreme-angular';

// Service imports
import { VendorAccountEditService } from '../../_services/vendor-account-edit.service';
import { ServerErrorService } from '../../../_services/shared-services/server-error.service';

// constants imports
import { StringFormatConstants } from '../../../_constants/string-format-constants';

// Model imports
import { VendorAccountHistoryResultDto } from '../../_models/vendor-account-history-result-dto';
import { VendorAccountHistoryParameterDto } from '../../_models/vendor-account-history-parameter-dto';
import { VendorAccountParametersDto } from '../../_models/vendor-account-parameters-dto';

@Component({
    selector: 'app-vendor-account-history',
    templateUrl: './vendor-account-history.component.html',
    styleUrls: ['./vendor-account-history.component.scss']
})
export class VendorAccountHistoryComponent implements OnInit {
    @ViewChild('historyPopup', { static: false }) historyPopup: DxPopupComponent;

    @Input() communityId: number;
    @Input() communityName: string;
    @Input() vendorAccountId: number;
    @Input() associationVendorId: number;
    @Input() vendorName: string;
    @Input() vendorAccountNumber: string;
    @Input() visible: boolean;

    @Output() vendorAccountHistoryClose = new EventEmitter<any>();

    source: VendorAccountHistoryResultDto[];
    hasGridSourceData = false;
    loadingVisible = false;
    noDataText: string;
    dateFormat = StringFormatConstants.dateFormat;

    iconClose = IconConstants.CROSS_MARK;

    constructor(
        private readonly vendorAccountEditService: VendorAccountEditService,
        private readonly errorService: ServerErrorService
    ) {}

    ngOnInit() {
        this.getVendorAccountHistoryLog();
    }

    onRefreshLogsClick(): void {
        this.getHistoryLog();
    }

    onHistoryPopUpClose(): void {
        this.historyPopup.visible = false;
        this.vendorAccountHistoryClose.emit();
    }

    private getHistoryLog(): void {
        if (this.associationVendorId && this.vendorAccountId) {
            this.getVendorAccountHistoryLog();
        }
    }

    private getVendorAccountHistoryLog(): void {
        const baseParams: VendorAccountParametersDto = new VendorAccountParametersDto();
        baseParams.communityId = this.communityId;
        baseParams.associationVendorId = this.associationVendorId;
        baseParams.vendorAccountId = this.vendorAccountId;

        this.loadingVisible = true;
        this.vendorAccountEditService.getVendorAccountHistory(baseParams).subscribe(
            (result: VendorAccountHistoryResultDto[]) => {
                this.source = result;
                this.hasGridSourceData = false;
                setTimeout(() => {
                    if (this.source.length > 0) {
                        this.hasGridSourceData = true;
                    } else {
                        this.hasGridSourceData = false;
                        this.noDataText = 'There is no vendor account history data.';
                    }
                    this.loadingVisible = false;
                }, 200);
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }

    public refreshVendorAccountHistory(): void {
        this.getVendorAccountHistoryLog();
    }
}
